<template>
  <table
    class="table table-striped mb-0 mt-3"
    v-if="selectedData?.postpones?.length"
  >
    <thead class="thead-light">
      <th>Postponed Date</th>
      <th>Postponed (RH)</th>
      <th>Postponed Notes</th>
    </thead>
    <tbody>
      <tr v-for="(postpone, index) in selectedData.postpones" :key="index">
        <td class="font-semibold text-black">{{
          formatDate(postpone.extra_date)
        }}</td>
        <td class="font-semibold text-black"
          >{{ formatHours(postpone.extra_hours) }} Hours</td
        >
        <td class="font-semibold text-black">{{ postpone.reason }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'TablePostponed',
  props: {
    selectedData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString(undefined, options)
    },
    formatHours(hours) {
      return hours?.toLocaleString() || '0'
    },
  },
}
</script>
